import { Suspense, type ReactNode } from 'react';
import { Navbar } from './Navbar';
import { PageSkeleton } from '../ui/Skeleton';
import { useRouteTitle } from '../../hooks/usePageTitle';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  // Titles come from the navigation labels; a page's PageHeader can override them.
  useRouteTitle();
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navbar />
      <main className="px-4 py-6 sm:px-6 lg:px-8">
        <Suspense fallback={<PageSkeleton />}>{children}</Suspense>
      </main>
    </div>
  );
}
